/* LuxuryPet theme scripts */
(() => {
  'use strict';

  const theme = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const parser = new DOMParser();

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.hidden = true), 2600);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    const focusTarget = $('.drawer__close', drawer);
    if (focusTarget) setTimeout(() => focusTarget.focus(), 50);
    return true;
  }

  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    closeSearch();
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.getAttribute('data-drawer-open');
      if (document.getElementById(id)) {
        e.preventDefault();
        openDrawer(id);
      }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    const interval = (parseInt(bar.dataset.interval, 10) || 4) * 1000;
    let i = 0;
    setInterval(() => {
      if (bar.classList.contains('announcement--split') && window.innerWidth >= 990) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Search ---------- */
  const searchModal = $('[data-search-modal]');

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    setTimeout(() => $('[data-predictive-input]', searchModal)?.focus(), 50);
  }

  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      openSearch();
    } else if (e.target.closest('[data-search-close]') || e.target === searchModal) {
      closeSearch();
    }
  });

  const predictiveInput = $('[data-predictive-input]');
  const predictiveResults = $('[data-predictive-results]');
  let searchTimer;

  if (predictiveInput && predictiveResults) {
    predictiveInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = predictiveInput.value.trim();
      if (q.length < 2) {
        predictiveResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(async () => {
        try {
          const url = `${theme.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const res = await fetch(url.replace('//search', '/search'));
          const data = await res.json();
          const products = data?.resources?.results?.products || [];
          if (!products.length) {
            predictiveResults.innerHTML = '';
            return;
          }
          predictiveResults.innerHTML = products
            .map(
              (p) => `<a href="${p.url}">
                ${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy" width="56" height="56">` : ''}
                <span>${escapeHtml(p.title)}<small>${formatMoney(Math.round(parseFloat(p.price) * 100))}</small></span>
              </a>`
            )
            .join('');
        } catch (err) {
          predictiveResults.innerHTML = '';
        }
      }, 220);
    });
  }

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function formatMoney(cents) {
    const format = theme.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withSep = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount':
          return `${withSep(',')}.${dec}`;
        case 'amount_no_decimals':
          return withSep(',');
        case 'amount_with_comma_separator':
          return `${withSep('.')},${dec}`;
        case 'amount_no_decimals_with_comma_separator':
          return withSep('.');
        default:
          return `${withSep('.')},${dec}`;
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => (el.textContent = count > 0 ? count : ''));
  }

  function renderCartDrawer(html) {
    const current = $('#CartDrawer');
    if (!current || !html) return;
    const doc = parser.parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    if (fresh) current.innerHTML = fresh.innerHTML;
  }

  async function refreshCartCount() {
    try {
      const res = await fetch(`${theme.routes.cart}.js`);
      const cart = await res.json();
      updateCartCount(cart.item_count);
      return cart;
    } catch (e) {
      return null;
    }
  }

  async function addToCart(items, button) {
    if (button) button.classList.add('is-loading');
    const useDrawer = theme.cartType === 'drawer' && $('#CartDrawer');
    try {
      const body = { items };
      if (useDrawer) body.sections = 'cart-drawer';
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || theme.strings.error);
        return;
      }
      if (!useDrawer) {
        window.location.href = theme.routes.cart;
        return;
      }
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      await refreshCartCount();
      openDrawer('CartDrawer');
    } catch (err) {
      toast(theme.strings.error);
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(key, quantity) {
    const drawer = $('#CartDrawer');
    const onCartPage = !!$('[data-main-cart]');
    try {
      const body = { id: key, quantity: Math.max(0, quantity) };
      if (drawer && !onCartPage) body.sections = 'cart-drawer';
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || theme.strings.error);
        return;
      }
      if (onCartPage) {
        window.location.reload();
        return;
      }
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      updateCartCount(data.item_count);
    } catch (err) {
      toast(theme.strings.error);
    }
  }

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.dataset.cartQty, parseInt(qtyBtn.dataset.qty, 10));
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], quick);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input) changeLine(input.dataset.cartInput, parseInt(input.value, 10) || 0);

    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(`${theme.routes.cart}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }

    const sort = e.target.closest('[data-sort-select]');
    if (sort) sort.form.submit();
  });

  /* ---------- Quantity selector (product) ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = e.target.closest('[data-quantity]');
    const input = wrap && $('input', wrap);
    if (!input) return;
    const val = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, val + (plus ? 1 : -1));
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(initProduct);

  function initProduct(section) {
    const jsonEl = $('[data-product-json]', section);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('form.product-form', section);
    const idInput = $('[data-variant-id]', section);
    const sectionId = section.dataset.sectionId;
    const productUrl = section.dataset.productUrl;

    /* Gallery */
    const main = $('[data-gallery-main]', section);
    const slides = main ? $$('.gallery__slide', main) : [];
    const thumbs = $$('[data-thumb]', section);
    const counter = $('[data-gallery-counter]', section);
    let currentIndex = 0;

    function goTo(index, smooth = true) {
      if (!main || !slides[index]) return;
      main.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    function setActive(index) {
      currentIndex = index;
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      const activeThumb = thumbs[index];
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    if (main && slides.length > 1) {
      let raf;
      main.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const index = Math.round(main.scrollLeft / main.clientWidth);
            if (index !== currentIndex) setActive(index);
          });
        },
        { passive: true }
      );
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.thumb, 10))));
      $('[data-gallery-prev]', section)?.addEventListener('click', () => goTo(Math.max(0, currentIndex - 1)));
      $('[data-gallery-next]', section)?.addEventListener('click', () => goTo(Math.min(slides.length - 1, currentIndex + 1)));
    }

    /* Variants */
    const picker = $('[data-variant-picker]', section);

    function selectedOptions() {
      return $$('.variant-picker', picker).map((fs) => {
        const select = $('[data-option-select]', fs);
        if (select) return select.value;
        const checked = $('[data-option-input]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    async function onVariantChange() {
      if (!product) return;
      const options = selectedOptions();
      $$('.variant-picker', picker).forEach((fs, i) => {
        const label = $('[data-option-value]', fs);
        if (label) label.textContent = options[i];
      });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === options[i]));
      const atc = $('[data-add-to-cart]', section);
      const sticky = $('[data-sticky-submit]', section);

      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = theme.strings.unavailable;
        }
        if (sticky) sticky.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (idx > -1) goTo(idx);
      }

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (sticky) sticky.disabled = !variant.available;

      try {
        const res = await fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`);
        const html = await res.text();
        const doc = parser.parseFromString(html, 'text/html');
        $$('[data-swap]', section).forEach((el) => {
          const fresh = doc.querySelector(`[data-swap="${el.dataset.swap}"]`);
          if (fresh && !el.contains($('[data-add-to-cart]', section))) el.innerHTML = fresh.innerHTML;
        });
        // availability state per option value
        $$('.variant-picker', picker).forEach((fs, i) => {
          const freshFs = doc.querySelectorAll('.variant-picker')[i];
          if (!freshFs) return;
          $$('.variant-pill', fs).forEach((pill, j) => {
            const freshPill = freshFs.querySelectorAll('.variant-pill')[j];
            if (freshPill) pill.classList.toggle('is-unavailable', freshPill.classList.contains('is-unavailable'));
          });
        });
      } catch (e) {
        /* keep current markup */
      }
    }

    if (picker) picker.addEventListener('change', onVariantChange);

    /* Bundle */
    const bundle = $('[data-bundle]', section);
    const bundleQty = $('[data-bundle-qty]', section);

    function currentVariant() {
      if (!product || !idInput) return null;
      return product.variants.find((v) => String(v.id) === String(idInput.value)) || null;
    }

    function updateBundlePrices() {
      if (!bundle) return;
      const v = currentVariant();
      if (!v) return;
      $$('.bundle__option', bundle).forEach((opt) => {
        const input = $('input', opt);
        const q = parseInt(input.value, 10) || 1;
        const saving = parseInt(input.dataset.saving, 10) || 0;
        const total = v.price * q - saving;
        const compare = saving > 0 ? v.price * q : (v.compare_at_price || 0) * q;
        const priceEl = $('[data-bundle-price]', opt);
        const compareEl = $('[data-bundle-compare]', opt);
        if (priceEl) priceEl.textContent = formatMoney(total);
        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = !(compare > total);
        }
      });
    }

    if (bundle) {
      bundle.addEventListener('change', (e) => {
        const input = e.target.closest('input[type="radio"]');
        if (!input) return;
        $$('.bundle__option', bundle).forEach((o) => o.classList.toggle('is-selected', o.contains(input)));
        if (bundleQty) bundleQty.value = input.value;
      });
      if (picker) picker.addEventListener('change', () => setTimeout(updateBundlePrices, 0));
    }

    /* Start gallery on the selected variant's image */
    if (product && idInput) {
      const start = product.variants.find((v) => String(v.id) === String(idInput.value));
      if (start && start.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(start.featured_media.id));
        if (idx > 0) requestAnimationFrame(() => goTo(idx, false));
      }
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', (e) => {
        if (theme.cartType !== 'drawer') return;
        e.preventDefault();
        const qtyInput = $('input[name="quantity"]', form);
        const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        addToCart([{ id: parseInt(idInput.value, 10), quantity }], $('[data-add-to-cart]', form));
      });
    }

    /* Sticky ATC */
    const stickyBar = $('[data-sticky-atc]', section);
    const buyBox = $('[data-buy-box]', section);
    if (stickyBar && buyBox && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      io.observe(buyBox);
      $('[data-sticky-submit]', stickyBar)?.addEventListener('click', () => {
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    /* Delivery estimate */
    $$('[data-delivery]', section).forEach((el) => {
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      const target = $('[data-delivery-dates]', el);
      if (!target || isNaN(min) || isNaN(max)) return;
      const addBusinessDays = (days) => {
        const d = new Date();
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          const day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      };
      const fmt = (d) => d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
      target.textContent = `${fmt(addBusinessDays(min))} – ${fmt(addBusinessDays(max))}`;
    });
  }

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const buttons = $$('[data-tab]', wrap);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
          const panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      });
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.product-grid')) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = parser.parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.remove();
    } catch (e) {
      el.remove();
    }
  });
})();
